var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHelp = function SvgHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 11,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.562 6.766V6.5c0-.574.392-.714.924-.896 1.078-.378 1.876-1.344 1.876-2.702 0-1.68-1.204-2.716-2.87-2.716C1.84.186.566 1.236.566 3.154H2.26c.028-.77.602-1.218 1.204-1.218.672 0 1.148.378 1.148 1.064 0 .378-.224.826-.728 1.036l-.504.196c-1.162.476-1.428 1.176-1.33 2.254l.014.28h1.498Zm-.756 3.36c.644 0 1.176-.476 1.176-1.134 0-.658-.532-1.12-1.176-1.12-.63 0-1.162.462-1.162 1.12 0 .658.532 1.134 1.162 1.134Z"
  })));
};
export default SvgHelp;